<template>
  <div style="height: 100%;">
    <!--视频监控-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
          style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>视频监控</span>
    </div>

    <no-data style="margin-top: 40%" v-if="videoTotal < 1"></no-data>
    <div v-else>
      <el-row style="padding-left: 30px;padding-top:18%;font-size: 0.9rem">
        <DVRVideoComponent :properties="JSON.parse(videoList[currentVideo].portProperties)"
                           style="width: 75%;margin-top: -2%"
                           :deviceInfo="videoList[currentVideo]"
                           v-if="videoList[currentVideo].typeEngName === 'PM_DVR'"></DVRVideoComponent>
        <div style="width: 75%;border: 1px solid #fff" v-else>
          <video-component :channel="1"
                           :device-info="videoList[currentVideo]"
                           :properties="JSON.parse(videoList[currentVideo].portProperties)"></video-component>
        </div>
        <div style="width: 75%;margin-top: 5px;">
          <span>{{ videoList[currentVideo].name }}</span>
        </div>
      </el-row>
      <el-row style="padding-left: 30px;margin-top:20px;width:75%;text-align: center" v-if="videoTotal > 1">
        <el-pagination
            :page-count="videoTotal"
            :small="true"
            @current-change="change"
            layout="prev, pager, next">
        </el-pagination>
      </el-row>
    </div>
  </div>
</template>

<script>
import VideoComponent from "@/components/video/VideoComponent";
import {getHistoryBySpacePoint} from "@/network/measuring-point-history";
import NoData from "@/components/NoData";
import DVRVideoComponent from "@/components/video/DVRVideoComponent";

export default {
  name: "Video",
  components: {VideoComponent, NoData, DVRVideoComponent},
  mounted() {
    this.getData();
  },
  props: {
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId() {
      this.getData();
    },
  },
  data() {
    return {
      typeList: ["Video_vlc", "PM_CAM", "PM_Video", 'PM_DVR'],
      pointCodes: [],
      videoList: [],
      currentVideo: 0,
      videoTotal: 0,
    }
  },
  methods: {
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.videoList = []
            res.data.forEach(item => {
              item.deviceInfoList.forEach(device => {
                this.videoList.push(device)
              })
            })
            this.videoTotal = this.videoList.length
          }
        }
      })
    },
    change(page) {
      this.currentVideo = page - 1;
    },
  }
}
</script>

<style scoped>
</style>
